import { WhiteLabelPortalEnums } from '@/common/enums/whiteLabelPortalEnums'

export const getWhiteLabelPortalName = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_NAME)
}
export const getWhiteLabelLoginHeading = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGIN_HEADING)
}

export const getWhiteLabelLoginSubHeading = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGIN_SUBHEADING)
}

export const getWhiteLabelSignupHeading = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_SIGNUP_HEADING)
}

export const getWhiteLabelSignupSubHeading = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_SIGNUP_SUBHEADING)
}

export const getWhiteLabelPortalLogo = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGO)
}
export const getWhiteLabelPortalLogoSize = () => {
  const height = sessionStorage.getItem(
    WhiteLabelPortalEnums.PORTAL_LOGO_HEIGHT,
  )
  const width = sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGO_WIDTH)
  if (!height || !width) return null
  return {
    height,
    width,
  }
}

export const getWhiteLabelPortalFavicon = () => {
  return (
    sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_FAVICON) ||
    sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_LOGO)
  )
}
export const getWhiteLabelPortalPrimaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_PRIMARY_COLOR)
}
export const getWhiteLabelPortalOnPrimaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_ON_PRIMARY_COLOR)
}
export const getWhiteLabelSidebarLogo = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_SIDEBAR_LOGO)
}
export const getWhiteLabelPortalSecondaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_SECONDARY_COLOR)
}
export const getWhiteLabelPortalOnSecondaryColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_ON_SECONDARY_COLOR)
}
export const getWhiteLabelPortalBackgroundColor = () => {
  return sessionStorage.getItem(WhiteLabelPortalEnums.PORTAL_BACKGROUND_COLOR)
}
export const getWhiteLabelPortalOnBackgroundColor = () => {
  return sessionStorage.getItem(
    WhiteLabelPortalEnums.PORTAL_ON_BACKGROUND_COLOR,
  )
}

export const isBionicSite = () => {
  const bionicPortals = [
    'my.bionicwp.com',
    'staging-customer.bionicwp.com',
    'staging-wl-front.bionicwp.com',
    'front.redesign.bionicwp.dev',
  ]
  const currentHost = sessionStorage.getItem(
    WhiteLabelPortalEnums.PORTAL_DOMAIN,
  )
  return bionicPortals.some((portal) => currentHost?.includes(portal))
}

// Wait until wl.js populates sessionStorage sentinel or timeout
export async function waitForWhiteLabelReady(
  maxWaitMs = 3000,
  intervalMs = 50,
): Promise<boolean> {
  const start = Date.now()
  let checks = 0

  // TEMP LOGS: verify WL readiness wait behavior
  console.debug('[WL] waitForWhiteLabelReady: start', { maxWaitMs, intervalMs })

  const hasWhiteLabelSession = (): boolean => {
    try {
      const primaryColor = sessionStorage.getItem(
        WhiteLabelPortalEnums.PORTAL_PRIMARY_COLOR,
      )
      const secondaryColor = sessionStorage.getItem(
        WhiteLabelPortalEnums.PORTAL_SECONDARY_COLOR,
      )
      return !!(primaryColor && secondaryColor)
    } catch (e) {
      return false
    }
  }

  if (hasWhiteLabelSession()) {
    const elapsed = Date.now() - start
    console.debug('[WL] waitForWhiteLabelReady: already ready', {
      elapsedMs: elapsed,
    })
    return true
  }

  return await new Promise((resolve) => {
    const check = () => {
      checks++
      if (hasWhiteLabelSession()) {
        const elapsed = Date.now() - start
        console.debug('[WL] waitForWhiteLabelReady: ready', {
          elapsedMs: elapsed,
          checks,
        })
        resolve(true)
        return
      }
      if (Date.now() - start >= maxWaitMs) {
        const elapsed = Date.now() - start
        console.warn('[WL] waitForWhiteLabelReady: timeout', {
          elapsedMs: elapsed,
          checks,
        })
        resolve(false)
        return
      }
      setTimeout(check, intervalMs)
    }
    check()
  })
}
